module.exports = __webpack_public_path__ + "d8bcbe724fd6f4ba44d0ee6a2675890f.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-400italic.woff2
// module id = 665
// module chunks = 0